<template>
    <div class="w-full md:w-fit">
        <Button
            @click.stop="show = true"
            :disabled="attendance.shouldDisableNoShowToggleAction()"
            color="light"
            size="small"
            class="w-full"
            :iconName="attendance.getNoShowToggleActionIconName()"
            iconClass="w-4 h-4"
        >
            {{ attendance.getNoShowToggleActionLabel() }}
        </Button>

        <ModalConfirmation
            :show="show"
            :action="submit"
            color="warning"
            :title="modalTitle"
            :actionText="attendance.getNoShowToggleActionLabel()"
            :actionProcessing="apiFormRef?.loading.valueOf()"
            @close="show = false"
        >
            <template #content>
                <div class="text-gray-500 text-center">
                    This action is a manual attendance correction.
                </div>
            </template>
        </ModalConfirmation>

        <ApiForm
            :url="
                urlFactory.makeMeetingAttendanceToggleNoShowUrl(
                    attendance.meetingId,
                    attendance.id,
                )
            "
            method="POST"
            :disableCatch="false"
            ref="apiFormRef"
        />
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { computed, ref, type PropType } from 'vue'
    import Button from '@/Shared/Component/Button.vue'
    import ModalConfirmation from '@/Shared/Component/ModalConfirmation.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import Attendance from '@/App/Booking/Attendance/Entity/Attendance'
    import MeetingData from '@/App/Booking/Meeting/Entity/MeetingData'
    import ApiFormResponseType from '@/Shared/Component/Forms/ApiFormResponseType'
    import { ResponseJsonKeyEnum } from '@/Shared/AutoGenerated/Main'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'

    const emits = defineEmits<{
        onSuccess: [{ meetingData: MeetingData }]
    }>()

    const props = defineProps({
        attendance: {
            type: Object as PropType<Attendance>,
            required: true,
        },
    })

    const show = ref(false)
    const apiFormRef = ref<ApiFormRefType>(null)

    const modalTitle = computed(() => {
        return props.attendance.isNoShow()
            ? 'Are you sure you want to revert this attendee to completed?'
            : 'Are you sure you want to mark this attendee as no-show?'
    })

    const submit = () => {
        apiFormRef.value
            ?.submit()
            ?.then((response: ApiFormResponseType) => {
                show.value = false

                emits('onSuccess', {
                    meetingData: response.getHydratedMeetingData(
                        ResponseJsonKeyEnum.App_Meeting_ToggleNoShow_MeetingDataData,
                    ),
                })
            })
            ?.catch(() => {
                show.value = false
            })
    }
    const urlFactory = new UrlFactory()
</script>
